import $ from '/js/header/jquery';
import Swiper from 'swiper/bundle';
import { Config } from "/js/config/Config";


const config = new Config();
$(async () => {
    await config.ensureLoaded();
    await board(); //게시판
    await news(); //부동산뉴스
    await Dates();
    await NewItem();
    await statisticsItem();

    // 샘플물건 동적뿌리기
    await samples();
    // 전문가코멘트 동적 뿌리기
    await comments();

    // 경매일정, 공고신건, 경매통계 show,hide
    $('.DateAc').on('click', (e) =>{
        $('.DateBtn li').removeClass('on');
        $(e.currentTarget).addClass('on');
        $('[class^=DateView]').hide();
        $('.DateViewAc').show();
    })

    $('.DateNew').on('click', (e) =>{
        $('.DateBtn li').removeClass('on');
        $(e.currentTarget).addClass('on');
        $('[class^=DateView]').hide();
        $('.DateViewNew').show();
        $('.DateViewNew .tab-pane').show();
    })

    $('.DateStats').on('click', (e) =>{
        $('.DateBtn li').removeClass('on');
        $(e.currentTarget).addClass('on');
        $('[class^=DateView]').hide();
        $('.DateViewStats').show();
        $('.DateViewStats .tab-pane').show();
    })
    // 경매일정, 공고신건, 경매통계 show,hide

	//메인광고
	if ($(".MainBanner").data("count") > 1) {
		new Swiper("#MainSwiper", {
			effect: "fade",
			autoplay: {
				delay: 7000,
				disableOnInteraction: false
			},
			speed: 1000,
			loop: true,
			pagination: {
				el: ".MainPage",
				clickable: true,
			},
			navigation: {
				nextEl: ".MainNext",
				prevEl: ".MainPrev"
			},
		});
	} else {
		$(".MainPrev, .MainNext").hide();
		$('.MainNext').css('display', 'none');
	}
	//이벤트광고(결제관련)
	if ($(".EventBanner").data("count") > 1) {
		new Swiper("#EventSwiper", {
			effect: "fade",
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			speed: 1000,
			loop: true,
			pagination: {
				el: ".EventPage",
				clickable: true,
			},
			navigation: {
				nextEl: ".EventNext",
				prevEl: ".EventPrev"
			},
		});
	} else {
		$(".EventPrev, .EventNext").hide();
		$('.EventPage').css('display', 'none');
	}
    
    $(`.sample_unit`).on('click', (e) => {
        const tid = $(e.currentTarget).data('tid');
        cntsView(tid, '1');
    })
})

//게시판
function board() {
    let html = "";
    $.ajax(
        {
            type: "POST",
            url: "/res/main.php",
            data: "mode=notice",
            dataType: "JSON",
            success: function (data) {
                $.each(data.item, (key, item) => {
                    html += `
                        <div class='swiper-slide noticeSlide'>
                            <a href='/board/boView.php?board_id=${item.boardId}&idx=${item.idx}' class='noticeMent'>
                                <span class='noticeNewMark'>${item.newMark}</span>
                                <span class='noticeText'>${item.tit}</span>
                                <span class='gray no-mobile noticeDate' style='padding-left:20px'>${item.wdt}</span>
                            </a>
                        </div>
                    `;
                });

                $("#sactionBoard").html(html);
                // 스와이퍼 스크립트
                // .swiper-button-prev, .swiper-button-next는 커스텀 css로만 보여지고 기본버튼은 안보여야함
                var swiper = new Swiper(".NoticeSwiper", {
                    autoplay: {delay: 3000, disableOnInteraction: false},
                    speed: 500,
                    loop: true,
                    direction: "vertical",
                    navigation: {
                        nextEl: ".noticeNext",
                        prevEl: ".noticePrev"
                    }
                });
                // hover 이벤트
                $(".NoticeSwiper").on("mouseenter", () => {
                    swiper.autoplay.stop();
                    $(".noticeMent").css({"color": "black"});
                }).on("mouseleave", () => {
                    swiper.autoplay.start();
                    $(".noticeMent").css({"color": ""});
                });
            },
            error: function (xhr, status, error) {
            }
        });
}
function news() {
    let html = "";
    $.ajax(
        {
            type: "POST",
            url: "/res/main.php",
            data: "mode=news",
            dataType: "JSON",
            success: (data) => {
                $.each(data.item, (key, item) => {
                    html += `
                        <div class='swiper-slide newsSlide' style='background:#F6F8F9;padding:0 15px 0px 15px;width:350px'>
                            <a href='/board/boView.php?board_id=${item.boardId}&idx=${item.idx}' class='noticeMent'>
                                <div class='noticeMentTitle'>
                                    <span>New</span>
                                </div>
                                <div class='noticeMentTxt bold_500'>
                                    <div class='black txt_ellipsis_1h f16'>
                                        <u>${item.tit}</u>
                                    </div>
                                </div>
                                <div class='gray noticeMentTxt'>관리자 / ${item.wdt}</div>
                                <div class='gray noticeMentTxt'>${item.content}</div>
                            </a>
                        </div>
                    `;
                });

                $("#sactionNews").html(html);
                // 스와이퍼 스크립트

                var swiper = new Swiper(".NewsSwiper", {
                    slidesPerView: 4,
                    spaceBetween: 10,
                    autoplay: {delay: 3000, disableOnInteraction: false},
                    speed: 500,
                    //loop: true,
                    direction: "vertical",
                });
                $(".NewsSwiper").hover(function () {
                    swiper.autoplay.stop();
                }, function () {
                    swiper.autoplay.start();
                });
            },
            error: function (xhr, status, error) {
            }
        });
}
function Dates() {
    const thisWeek = makeThisWeek();
    wrapDates(thisWeek);
    getbidCounts(thisWeek);
}
function makeThisWeek() {
    // 오늘 날짜
    const today = new Date();
    // 이번주 월-금까지의 날짜를 배열로 담습니다.
    const thisWeek = [];
    // 오늘의 요일을 구합니다.
    const todayOfWeek = today.getDay();
    // 월요일을 구할때 쓰이는 변수입니다.
    let plusDate = 1;
    if(todayOfWeek === 6) {
        // 토요일일 경우 2일을 더해줍니다.
        plusDate = 8;
    }
    // 이번주 월요일을 구합니다.
    const monday = new Date(today.setDate(today.getDate() - todayOfWeek + plusDate));
    // 이번주 월요일부터 금요일까지의 날짜를 thisWeek 배열에 담습니다.
    for (let i = 0; i < 5; i++) {
        thisWeek.push(new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + i));
    }
    return thisWeek;
}
function wrapDates(thisWeek) {
    let Div = "";
    // thisWeek 배열에 담긴 날짜들을 YYYY-MM-DD 형식으로 변환합니다.
    thisWeek.forEach((date) => {
        // mm-dd (요일)
        const month = date.getMonth() + 1;
        // 1의자리일경우 0을 붙인것을 mothString에 담습니다.
        let monthString = month;
        if (month < 10) {
            monthString = "0" + month;
        }

        let day = date.getDate();
        // day가 1자리 숫자일 경우 앞에 0을 붙여줍니다.
        // ex) 1 -> 01
        if (day < 10) {
            day = "0" + day;
        }
        const week = ['일', '월', '화', '수', '목', '금', '토'][date.getDay()];
        let todayClass = "";
        if(date.getDate() === new Date().getDate()) {
            todayClass = " today active";
        }
        Div += `
            <div class="nav-item nav-link${todayClass}" data-date="${date.getFullYear()}-${monthString}-${day}" role="tab" aria-selected="false">
                ${monthString}월-${day}일 (${week})
                <span id="${date.getFullYear()}-${monthString}-${day}" class="value">0건</span>
            </div>
        `
        $("#dateList").html(Div);
    });
    $(".nav-item").click(function () {
        $(".nav-link").removeClass("active");
        $(this).addClass("active");
        const date = $(this).data("date");
        $(".tab-pane").css("display", "none");
        $(`#week${date}`).css("display", "block");
    });
}
function getbidCounts(thisWeek){
    // thisWeek 의 0번째 값이 firstDate
    const firstDate = thisWeek[1].toISOString().split('T')[0];
    $.ajax({
        type: "post",
        url: "/res/main.php",
        data: "mode=week_schedule&auct_date=" + firstDate,
        dataType: "JSON",
        success: function (data) {
            wrapBidData(data);
        },
        error: function (xhr, status, error) {
        }
    });
}
function wrapBidData (data) {
    let Div = "";
    Object.entries(data.item).forEach(([date, value]) => {
        const count = Object.keys(value).length;
        $(`#${date}`).text(`${count}건`);
        const year = date.split("-")[0];
        const month = date.split("-")[1];
        const day = date.split("-")[2];
        const week = ['일', '월', '화', '수', '목', '금', '토'][new Date(year, month - 1, day).getDay()];
        let before = 0;
        let now = 0; 
        let end = 0;
        const beforeClass = " color-warm-pink";
        const nowClass = " color-cornflower";
        let className = "";
        // todayString을 선언합니다. 그리니치에서 9시간을 더한 값입니다.
        const today = new Date();
        today.setHours(today.getHours() + 9);
        const todayString = today.toISOString().split('T')[0];
        if(date === todayString) {
            const currentHour = new Date().getHours();
            if(currentHour < 11) {
                before = count;
            } else if (currentHour >= 11 && currentHour <= 13) {
                className = nowClass;
                now = count;
            } else {
                className = beforeClass;
                end = count;
            }
        } else if (date < todayString) {
            className = beforeClass;
            end = count;
        } else {
            before = count;
        }
        Div += `
            <div id="week${date}" class="tab-pane" style="display:none;">
                <div class="main-week-data">
                    <div>
                        <div class="main-week-data-table show-pc">
                            <div class="data-inner">
                                <div class="date">
                                    <div class="year-txt">${year}</div>
                                    <div class="day-txt">${month}월 ${day}일</div>
                                    <div class="week-txt">${week}요일</div>
                                </div>
                                <div class="value-list">
                                    <div class="value-list-cell"><em>개찰전</em>
                                        <strong class="color-black-two">${before}건</strong>
                                    </div>
                                    <div class="value-list-cell"><em>개찰중</em>
                                        <strong class="color-cornflower">${now}건</strong>
                                    </div>
                                    <div class="value-list-cell"><em>개찰종료</em>
                                        <strong class="color-warm-pink">${end}건</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="main-week-data-item w-810">
                            <div class="main-week-data-label">
                                <div class="label-txt color-black">개찰전</div>
                                <div class="label-txt color-cornflower">개찰중</div>
                                <div class="label-txt color-warm-pink">개찰종료</div>
                            </div>
                            <div class="data-inner">
                                <div class="main-week-data-item-list">
                                    <div class="main-week-data-item-list-inner">
                                    ${Object.keys(value).length === 0 ? "" : `
                                        <div class="main-week-data-item-list-cell">
                                            <a href="ca/caDtList.php?bidDt=${date}" class="btn-main-week-link${className}">전체법원</a>
                                        </div>`}
                                    ${Object.entries(value).map(([itemKey, itemValue]) => {
                                        return `
                                            <div class="main-week-data-item-list-cell">
                                                <a href="ca/caDtList.php?bidDt=${date}&sptCd=${itemValue.split("_")[0]}&dptCd=${itemValue.split("_")[1]}" class="btn-main-week-link${className}">${itemKey}</a>
                                            </div>
                                        `
                                    }).join("")}
                                    ${Object.keys(value).length === 0 ? `<div class="main-week-data-item-list-cell">오늘은 결매 일정이 없습니다.</div>` : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `
    });
    // 초기화 후 뿌리기
    $(".tab-content").html("");
    $(".tab-content").html(Div);
    // 오늘 날짜에 해당하는 탭을 활성화
    // 한국시간 적용
    const today = new Date();
    today.setHours(today.getHours() + 9); // UTC+9 시간대(KST)로 설정
    const todayString = today.toISOString().split('T')[0];
    
    $(`#week${todayString}`).css("display", "block");

    // 만약 nav-item에 active 클래스가 없다면 첫번째 nav-item에 active 클래스를 추가합니다.
    if (!$(".nav-item").hasClass("active")) {
        $(".nav-item").first().addClass("active");
        const date = $(".nav-item").first().data("date");
        $(`#week${date}`).css("display", "block");
    }
}

function cntsView(tid, free) {
    window.open("/ca/caView.php?tid=" + tid + '&free=' + free, "cntsView", "width=1200,height=" + (screen.availHeight - 50) + ",top=0,left=10,scrollbars=yes,resizable=yes").focus();
}

function pacntsView(tid, free) {
    window.open("/pa/paView.php?cltrNo=" + tid + '&free=' + free, "cntsView", "width=1200,height=" + (screen.availHeight - 50) + ",top=0,left=10,scrollbars=yes,resizable=yes").focus();
}

// 오늘 공고된 신건
function NewItem() {
    getNewItem();
}

function getNewItem(date) {
    $.ajax({
        type: "post",
        url: "/res/main.php",
        data: {
            mode: "newItem",
            date: date
        },
        dataType: "JSON",
        success: (data) => {
            wrapNewItem(data);
        },
        error: function (xhr, status, error) {

        }
    });
}
function wrapNewItem(data) {
    const year = data.date.split("-")[0];
    const month = data.date.split("-")[1];
    const day = data.date.split("-")[2];
    const week = ['일', '월', '화', '수', '목', '금', '토'][new Date(year, month - 1, day).getDay()];
    // item.date를 기준으로 전날과 다음날을 설정
    const date = new Date(year, month - 1, day);
    // 한국시간기준으로 9시간 더하기
    date.setHours(date.getHours() + 9);
    const beforeDate = new Date(date);
    beforeDate.setDate(date.getDate() - 1);
    const afterDate = new Date(date);
    afterDate.setDate(date.getDate() + 1);
    
    const beforeDateString = beforeDate.toISOString().split('T')[0];
    const afterDateString = afterDate.toISOString().split('T')[0];

    // 실제 bidDt는 date보다 14일 뒤인것임
    const realBidDt = new Date(date);
    realBidDt.setDate(date.getDate() + 14);
    const realBidDtString = realBidDt.toISOString().split('T')[0];
    
   
    let Div = "";
    const count = data.totalCount;
    const bdatemonth = data.bdate.split("-")[1];
    const bdateday = data.bdate.split("-")[2];
    
    // 경매가 없는날도 지나가야하므로 콘텐츠를 정제해야함
    let content = `
                <div class="main-week-data-item-list-inner">
                    <div class="main-week-data-item-list-cell">
                        공고일정이 없습니다.
                    </div>
                </div>
                `;
    if(count > 0) {
        content = `
            <div class="main-week-data-item-list-inner">
                <div class="main-week-data-item-list-cell">
                    <a href="ca/caNewList.php?bidDt=${realBidDtString}" class="btn-main-week-link">전체법원</a>
                </div>
            ${Object.entries(data.item).map(([itemKey, itemValue]) => {
                return `
                    <div class="main-week-data-item-list-cell">
                        <a href="ca/caNewList.php?bidDt=${realBidDtString}&sptCd=${itemValue.split("_")[0]}&dptCd=${itemValue.split("_")[1]}" class="btn-main-week-link">${itemKey}</a>
                    </div>
                `
                }).join("")}
            </div>
        `;
    }
    Div += `
        <div id="new${data.date}" class="tab-pane">
                    <div class="main-week-data">
                        <div class="info-banner-box show-pc">
                             <span class="f14 txt-dark-gray">신건검색 : 신건일정으로 신건물건을 달력으로 확인 하세요!</span>
                             <a href="/ca/caNew.php"><span class='btn_dooin btn_s radius_20 hand' style='padding:3px 15px;margin-left:20px'>바로가기</span></a>
                        </div>
                        <div>
                            <div class="main-week-data-table show-pc">
                                <div class="data-inner">
                                    <div class="date">
                                        <div class="year-txt">${year}</div>
                                        <div style="display:flex;justify-content: space-around">
                                            <span data-date="${beforeDateString}" id="beforeNew" style="display:flex;align-items: center;">
                                                <svg height='20px' class="hand" viewBox='0 -960 960 960' width='20px' fill='#5f6368'><path d='M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z'></path></svg>
                                            </span>
                                            <div class="day-txt">${month}월 ${day}일</div>
                                            <span data-date="${afterDateString}" id="afterNew" style="display:flex;align-items: center;width:20px">
                                                <svg id="afterNewArrow" class="hand" height='20px' viewBox='0 -960 960 960' width='20px' fill='#5f6368'><path d='m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z'></path></svg>
                                            </span>
                                        </div>
                                        <div class="week-txt">${week}요일</div>
                                    </div>
                                    <div class="value-list" style="display:flex;justify-content:center;">
                                        <div class="value-list-cell"> <em><span class="blue">${bdatemonth}월${bdateday}일</span> 신건(물건)</em>
                                            <strong class="color-black-two">${count}건</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="main-week-data-item w-810">
                                <div class="main-week-data-label">
                                    <span style='font-size:14px; line-height: 20px;'>
                                        <span class="bold" style="color:#249AF3">[오늘 공고된 경매신건]</span>정보는 <span class='red'>해당일로 부터 14일 후 공고된 신건</span> 입니다.  신건물건의 상세정보는 다시 한 번 확인하세요.
                                    </span>
                                </div>
                                <div class="data-inner">
                                    <div class="main-week-data-item-list">
                                        ${content}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    `
    // 초기화 후 뿌리기
    $(".DateViewNew").html("");
    $(".DateViewNew").html(Div);

    // 만약 data.date가 오늘이면 #afterNew는 안보여야됨
    // today는 한국시간기준이어야함
    const today = new Date();
    today.setHours(today.getHours() + 9); // UTC+9 시간대(KST)로 설정
    const todayString = today.toISOString().split('T')[0];
    if(data.date === todayString) {
        $("#afterNewArrow").css("display", "none");
    } else {
        $("#afterNewArrow").css("display", "block");
        // 다음날짜 클릭
        $("#afterNew").click(() => {
            const date = $("#afterNew").data("date");
            getNewItem(date);
        });
    }

    // 이전날짜 클릭
    $("#beforeNew").click(() => {
        const date = $("#beforeNew").data("date");
        getNewItem(date);
    });
}

// 경매통계
function statisticsItem() {
    getStatisticsItem();
}

function getStatisticsItem(date) {
    // date값이 없으면 한국기준으로 어제로 설정
    if(date === undefined) {
        const today = new Date();
        today.setHours(today.getHours() + 9); // UTC+9 시간대(KST)로 설정
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        date = yesterday.toISOString().split('T')[0];
    }
    $.ajax({
        type: "post",
        url: "/res/main.php",
        data: {
            mode: "stats",
            auct_date: date
        },
        dataType: "JSON",
        success: (data) => {
            wrapStatisticsItem(data);
        },
        error: function (xhr, status, error) {

        }
    });
}

function wrapStatisticsItem(data) {
    const year = data.date.split("-")[0];
    const month = data.date.split("-")[1];
    const day = data.date.split("-")[2];
    const week = ['일', '월', '화', '수', '목', '금', '토'][new Date(year, month - 1, day).getDay()];
    // item.date를 기준으로 전날과 다음날을 설정
    const date = new Date(year, month - 1, day);
    // 한국시간기준으로 9시간 더하기
    date.setHours(date.getHours() + 9);
    const beforeDate = new Date(date);
    beforeDate.setDate(date.getDate() - 1);
    const afterDate = new Date(date);
    afterDate.setDate(date.getDate() + 1);
    
    const beforeDateString = beforeDate.toISOString().split('T')[0];
    const afterDateString = afterDate.toISOString().split('T')[0];

    let Div = "";
    let count = 0;
    if(data.totalCount > 0) {
        count = Object.keys(data.item).length;
    }
    // 경매가 없는날도 지나가야하므로 콘텐츠를 정제해야함
    let content = `
                <div class="main-week-data-item-list-inner">
                    <div class="main-week-data-item-list-cell">
                        통계자료가 없습니다.
                    </div>
                </div>
                `;
    if(data.totalCount > 0) {
        content = `
            <div class="main-week-data-item-list-inner">
                <div class="main-week-data-item-list-cell">
                    <a href="ca/caStats.php?statDvsn=1&year=${year}&mnth=${month}&day=${day}" class="btn-main-week-link">전체법원</a>
                </div>
            ${Object.entries(data.item).map(([itemKey, itemValue]) => {
                // 만약 itemValue가 1500보다 작으면 crt는 '10,11,12,13,14'로 설정하고 아니면 itemValue의 앞 2자를 따서 설정
                let crt = "";
                if(itemValue < 1500) {
                    crt = "10,11,12,13,14";
                } else {
                    crt = itemValue.toString().substring(0, 2);
                }
                const year = data.date.split("-")[0];
                const month = data.date.split("-")[1];
                const day = data.date.split("-")[2];
                return `
                    <div class="main-week-data-item-list-cell">
                        <a href="ca/caStats.php?statDvsn=1&crt=${crt}&spt=${itemValue}&year=${year}&mnth=${month}&day=${day}" class="btn-main-week-link">${itemKey}</a>
                    </div>
                `
                }).join("")}
            </div>
        `;
    }
    Div += `
        <div id="new${data.date}" class="tab-pane">
                    <div class="main-week-data">
                        <div class="info-banner-box show-pc">
                             <span class="f14 txt-dark-gray">매각통계 : 법원별통계와 지역별 통계 구분으로 일일, 월간, 연간 통계를 확인 할 수 있습니다.</span>
                             <a href="/ca/caStats.php"><span class='btn_dooin btn_s radius_20 hand' style='padding:3px 15px;margin-left:20px'>바로가기</span></a>
                        </div>
                        <div>
                            <div class="main-week-data-table show-pc">
                                <div class="data-inner">
                                    <div class="date">
                                        <div class="year-txt">${year}</div>
                                        <div style="display:flex;justify-content: space-around">
                                            <span data-date="${beforeDateString}" id="beforeStat" style="display:flex;align-items: center;">
                                                <svg height='20px' class="hand" viewBox='0 -960 960 960' width='20px' fill='#5f6368'><path d='M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z'></path></svg>
                                            </span>
                                            <div class="day-txt">${month}월 ${day}일</div>
                                            <span data-date="${afterDateString}" id="afterStat" style="display:flex;align-items: center;width:20px">
                                                <svg id="afterStatArrow" class="hand" height='20px' viewBox='0 -960 960 960' width='20px' fill='#5f6368'><path d='m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z'></path></svg>
                                            </span>
                                        </div>
                                        <div class="week-txt">${week}요일</div>
                                    </div>
                                    <div class="value-list" style="display:flex;justify-content:center;">
                                        <div class="value-list-cell"><em>경매통계</em>
                                            <strong class="color-black-two">${count}건</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="main-week-data-item w-810">
                                <div class="main-week-data-label">
                                    <span style='font-size:14px; line-height: 20px;'>
                                        <span class="bold" style="color:#FC5C7D">[경매통계정보]</span>는 전일 경매결과를 기준으로 제공됩니다.
                                    </span>
                                </div>
                                <div class="data-inner">
                                    <div class="main-week-data-item-list">
                                        ${content}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    `
    // 초기화 후 뿌리기
    $(".DateViewStats").html("");
    $(".DateViewStats").html(Div);

    // 만약 data.date가 어제이면 #afterNew는 안보여야됨
    // today는 한국시간기준이어야함
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    // 9시간 더함
    yesterday.setHours(yesterday.getHours() + 9);
    const yesterdayString = yesterday.toISOString().split('T')[0];

    if(data.date === yesterdayString) {
        $("#afterStatArrow").css("display", "none");
    } else {
        $("#afterStatArrow").css("display", "block");
        // 다음날짜 클릭
        $("#afterStat").click(() => {
            const date = $("#afterStat").data("date");
            getStatisticsItem(date);
        });
    }

    // 이전날짜 클릭
    $("#beforeStat").click(() => {
        const date = $("#beforeStat").data("date");
        getStatisticsItem(date);
    });
}

function samples() {
    $.ajax({
        type: "post",
        url: "/res/main.php",
        data: {
            mode: "samples"
        },
        dataType: "JSON",
        success: (data) => {
            wrapSampleItems(data);
        }
    });
}

function wrapSampleItems(data) {
    let html = "";
    
    const isMobile = window.innerWidth < config.responsiveInfo.tabletWidth;
    
    $.each(data.item, (key, item) => {
        const imgUrlBig = item.imgUrl.replace("T_", "");
        html += `
        <div class='swiper-slide'>
            <div class='sample_unit' data-tid='${item.tid}'>
                <div class='img'>${(isMobile) ? imgUrlBig : item.imgUrl}</div>
                <div class='sample_ment'>
                    <div>
                        <div class='fleft s_title f14'>${item.saNo} </div>
                        <div class='fright s_date f12'>${item.bidDt}</div>
                        <div class='clear'></div>
                    </div>
                    <div class='s_title txt_ellipsis_2h f14'>[${item.title}] ${item.adrs}</div>
                    <div class='h-15'></div>
                    <div class='Amtlabel bold f14'>
                        <div class='labelApslAmtBig'></div>
                        ${item.apslAmt}
                    </div>
                    <div class='Amtlabel bold f14'>
                        <div class='labelMinbAmtBig'></div>
                        <span class='blue'>(${item.minbPct}%)</span> ${item.minbAmt}
                    </div>
                </div>
            </div>
        </div>
        `;
    });
    
    $("#sample_swiper_wrapper").html(html);

    // Swiper 초기화 (breakpoints로 반응형 처리)
    new Swiper(".SampleSwiper", {
        slidesPerView: 'auto',
        spaceBetween: 15,
        slidesOffsetAfter: 15,
        freeMode: {
            enabled: true,
            sticky: false,
        },
        ...(isMobile && {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            }
        }),
        breakpoints: {
            950: {   // 950-1439px: 중간 화면 (자유 스크롤)
                slidesPerView: 'auto',
                spaceBetween: 15,
                freeMode: {
                    enabled: true,
                    sticky: false
                }
            },
            1440: {  // 1440px 이상: 큰 화면 (5개)
                slidesPerView: 5,
                spaceBetween: 20,
                slidesOffsetAfter: 0,
                grid: {
                    rows: 1,
                    fill: 'row'
                },
                freeMode: false,
                allowTouchMove: false
            }
        }
    });
    
    // 클릭 이벤트
    $(`.sample_unit`).on('click', (e) => {
        const tid = $(e.currentTarget).data('tid');
        cntsView(tid, 1);
    });
}

function comments() {
    $.ajax({
        type: "post",
        url: "/res/main.php",
        data: {
            mode: "comments"
        },
        dataType: "JSON",
        success: (data) => {
            wrapCommentItems(data);
        }
    });
}

function wrapCommentItems(data) {
    let html = "";
    
    const isMobileComment = window.innerWidth < config.responsiveInfo.tabletWidth;
    
    $.each(data.item, (key, item) => {
        const imgUrlBig = item.imgUrl.replace("T_", "");
        html += `
        <div class='swiper-slide'>
            <div class='comment_unit' data-tid='${item.tid}'>
                <div class='img commentTxt'>${(isMobileComment) ? imgUrlBig : item.imgUrl}</div>
                <div class='comment_ment'>
                    <div>
                        <div class='fleft comment_title f14'>${item.saNo} </div>
                        <div class='fright s_date f12'>${item.bidDt}</div>
                        <div class='clear'></div>
                    </div>
                    <div class='comment_title txt_ellipsis_2h f14'>${item.adrs}</div>
                    <div class='h-15'></div>
                    <div class='Amtlabel bold f14'>
                        <div class='labelApslAmtBig'></div>
                        ${item.apslAmt}
                    </div>
                    <div class='Amtlabel bold f14'>
                        <div class='labelMinbAmtBig'></div>
                        <span class='blue'>(${item.minbPct}%)</span> ${item.minbAmt}
                    </div>
                </div>
            </div>
        </div>
        `;
    });
    
    $("#comment_swiper_wrapper").html(html);
    
    // Swiper 초기화 (breakpoints로 반응형 처리)
    new Swiper(".CommentSwiper", {
        slidesPerView: 'auto',
        spaceBetween: 15,
        slidesOffsetAfter: 15,
        freeMode: {
            enabled: true,
            sticky: false,
        },
        ...(isMobileComment && {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            }
        }),
        breakpoints: {
            950: {   // 950-1439px: 중간 화면 (자유 스크롤)
                slidesPerView: 'auto',
                spaceBetween: 15,
                freeMode: {
                    enabled: true,
                    sticky: false
                }
            },
            1440: {  // 1440px 이상: 큰 화면 (5개)
                slidesPerView: 5,
                spaceBetween: 20,
                slidesOffsetAfter: 0,
                grid: {
                    rows: 1,
                    fill: 'row'
                },
                freeMode: false,
                allowTouchMove: false
            }
        }
    });
    
    // 클릭 이벤트
    $(`.comment_unit`).on('click', (e) => {
        const tid = $(e.currentTarget).data('tid');
        cntsView(tid, 1);
    });
}
